import { RemoteGetPersonByIdV2 } from 'data/usecases';
import { GetPersonByIdV2UseCaseInterface } from 'domain/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetPersonByIdV2 = (): GetPersonByIdV2UseCaseInterface =>
  new RemoteGetPersonByIdV2(makeApiUrlPerson(), makeAxiosHttpClient());
